import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Page from '../../components/Page';
import RequirementTemplateBuilder from '../../components/RequirementTemplateBuilder';
import LoadingSpinner from '../../components/Spinner';
import { getInsured } from '../../redux/modules/insured';
import { insuredRequirementTemplateBuilder } from '../../redux/reducer';

import UpdateRequirementsHeader from './components/UpdateRequirementsHeader';

const UpdateRequirementsPage = () => {
  const { requirementId, insuredId } = useParams();
  const dispatch = useDispatch();
  const currentTemplate = useSelector(insuredRequirementTemplateBuilder.selectCurrentRequirementTemplate);

  useEffect(() => {
    dispatch(insuredRequirementTemplateBuilder.updateOrCreateInsuredRequirementTemplate(requirementId));
  }, []);

  useEffect(() => {
    dispatch(getInsured(insuredId));
    dispatch(insuredRequirementTemplateBuilder.listInsurancePolicyTypes());
    dispatch(insuredRequirementTemplateBuilder.listDeletedPolicyTypes());
  }, []);

  return (
    <Page fixedHeight>
      <UpdateRequirementsHeader />
      {!currentTemplate ? (
        <Box><LoadingSpinner /></Box>
      ) : <RequirementTemplateBuilder blueprint={insuredRequirementTemplateBuilder} />}
    </Page>
  );
};

export default UpdateRequirementsPage;
